import { render, staticRenderFns } from "./moon.svg.vue?vue&type=template&id=349072e2&"
import script from "./moon.svg.vue?vue&type=script&lang=js&"
export * from "./moon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports